import { Box, Stack, Text } from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import GeneralEvents from './GeneralEvents.js';
import _ from 'lodash';
import { getEventData } from '../../services/EventList.js';
import Event from './Event.js';
import MyTabsNested from '../../components/MyTabsNested.js';

const EditEventRecord = () => {
  const { alias } = useParams();
  const [eventTitle, setEventTitle] = useState();
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = useMemo(() => [
    {
      id: "general", title: "General", Component: GeneralEvents, subTabs: [
        { id: "basic", title: "Basic", Component: Event }
      ]
    }
  ], []);

  useEffect(() => {
    const getBasicData = async () => {
      try {
        if (alias) {
          const result = await getEventData(alias);

          if (result && result?.data?.[0]) {
            setEventTitle(result?.data?.[0]?.event_title || result?.data?.[0]?.alias);
          }
        }
      } catch (error) {
        console.error('Error fetching Event data:', error);
      }
    };

    getBasicData();
  }, [alias]);

  // Redirect to default tab if no tab is specified
  useEffect(() => {
    const pathParts = location.pathname.split('/');
    if (pathParts?.length === 3 && alias) {
      // Redirect to the default tab/subTab
      navigate(`/events/${alias}/${tabs[0].id}/${tabs?.[0].subTabs?.[0].id}`, { replace: true });
    }
  }, [location.pathname, alias, navigate, tabs]);

  return (
    <Stack px="1rem" pb={'1rem'} width={"100%"}>
    <Box>
      <Text fontSize={"18px"} pt={2} fontWeight={"600"}>{_.capitalize(eventTitle)}</Text>
    </Box>
    <MyTabsNested orientation="vertical" list={tabs} urlBasePath={"/events"} />
  </Stack>
  );
};

export default EditEventRecord; 